import script from "./AppTableCreateButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTableCreateButton.vue?vue&type=script&setup=true&lang=js"

import "./AppTableCreateButton.vue?vue&type=style&index=0&id=5d2acd33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2acd33"]])

export default __exports__